module.exports = __webpack_public_path__ + "img/DefIMG_StoreLogo.d65d3e7c.svg";